import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconLibraryService {
  constructor(private matIconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {}

  registryIcon(): void {
    this.matIconRegistry
      .addSvgIcon('researches', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/researches.svg'))
      .addSvgIcon('sensors', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/sensors.svg'))
      .addSvgIcon('avatar', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/avatar.svg'))
      .addSvgIcon('message', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/message.svg'))
      .addSvgIcon('qrcode', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/qrcode.svg'))
      .addSvgIcon('check-circle', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/check-circle.svg'))
      .addSvgIcon('check-circle-3', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/check-circle-3.svg'))
      .addSvgIcon('plus', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/plus.svg'))
      .addSvgIcon('chart-line', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/chart-line.svg'))
      .addSvgIcon('clipboard', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/clipboard.svg'))
      .addSvgIcon('chart-pie', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/chart-pie.svg'))
      .addSvgIcon('reports', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/reports.svg'))
      .addSvgIcon('cloud-check', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/cloud-check.svg'))
      .addSvgIcon('minus-circle', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/minus-circle.svg'))
      .addSvgIcon('download', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/download.svg'))
      .addSvgIcon('error', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/error.svg'))
      .addSvgIcon(
        'rssi_excellent',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rssi/rssi_excellent.svg')
      )
      .addSvgIcon(
        'rssi_very_good',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rssi/rssi_very_good.svg')
      )
      .addSvgIcon('rssi_good', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rssi/rssi_good.svg'))
      .addSvgIcon('rssi_low', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rssi/rssi_low.svg'))
      .addSvgIcon(
        'rssi_very_low',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rssi/rssi_very_low.svg')
      )
      .addSvgIcon(
        'upload-cloud',
        this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/upload-cloud.svg')
      );
  }
}
